import {createSelector} from 'reselect';
import _ from 'lodash';

const selectNewFeature = (state) => state.newFeature;

const selectInstallations = (state) => state.installations;

const selectInstallationGroups  = createSelector([selectNewFeature], f => f.installationGroups)

const selectFilterGroups = (state) => {
  return state.newFeature.featureDefinitionId ? state.newFeature.filterGroups : state.featuresFiltersState.allFilterGroups;
}

export const getFilterGroups = createSelector(
  [selectFilterGroups], (filterGroups) => _.sortBy(filterGroups, f => f.name)
);

export const getActiveEditData = createSelector([selectNewFeature], (item) => item.edit);

export const getIsServerData = createSelector([selectNewFeature], item => item.isServerData);

export const getGroupName = createSelector([selectNewFeature], item => item.group);

export const getInstallationDDL = createSelector(
  [selectInstallations],
  (installations) => {
    var installationGroups = [];
    if (installations.installationGroups && installations.installationGroups.length > 0) {
      installations.installationGroups.forEach(ig => {
        if (ig && ig.installations && ig.installations.length > 0) {
          var installationGroup = {
            text: ig.customDisplayName || ig.featureGroup,
            items: []
          };
          ig.installations.forEach(i => {
            installationGroup.items.push({
              value: i,
              text: i.name
            })
          });
          installationGroups.push(installationGroup);
        }
      });
    }
    return installationGroups;
  }
)
export const getInstallationDDLNew = createSelector(
  [selectInstallationGroups],
  (installationGroupsFromState) => {
    var installationGroups = [];
    if (!_.isEmpty(installationGroupsFromState)) {
      installationGroupsFromState.forEach(ig => {
        if (ig && ig.installations && ig.installations.length > 0) {
          var installationGroup = {
            text: ig.customDisplayName || ig.featureGroup,
            items: []
          };
          ig.installations.forEach(i => {
            installationGroup.items.push({
              value: i,
              text: i.name,
              flags: [{
                text: 'QT',
                on: i.forQuotingTool
              }, {
                text: 'KV',
                on: i.forVisualizers.includes('kv')
              }, {
                text: 'BV',
                on: i.forVisualizers.includes('bv')
              }]
            });
          });
          installationGroups.push(installationGroup);
        }
      });
    }
    return installationGroups;
  }
)
